// Lib
import { handleActions } from 'redux-actions';

// Actions
import { setDashBoardStatistics } from './actions';

const initialState: any = {
  jobs: {
    active: null,
    watching: null,
    nonPublished: null,
  },
  candidates: {
    total: null,
    active: null,
    rejected: null,
    pending: null,
  },
  stages: [],
};

export default handleActions(
  {
    [setDashBoardStatistics as any]: (state, action) => action.payload,
  },
  initialState
);
